import ItemListPage from "./ItemListPage";

export default function Inbox() {
  return (
    <ItemListPage titleKey="nav.inbox" subtitleKey="dashboard.inboxSubtitle" testid="inbox-page" excludeCompleted />
  );
}
